export var StateTypes;

(function (StateTypes) {
  StateTypes["NONE"] = "NONE";
  StateTypes["CAMPAIGN_REQUESTED"] = "CAMPAIGN_REQUESTED";
  StateTypes["UI_REQUESTED"] = "UI_REQUESTED";
  StateTypes["UI_DISPLAYED"] = "UI_DISPLAYED";
})(StateTypes || (StateTypes = {}));

export var ErrorTypes;

(function (ErrorTypes) {
  ErrorTypes["INVALID_STATE"] = "INVALID_STATE";
})(ErrorTypes || (ErrorTypes = {}));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9lbnVtcy50cyJdLCJuYW1lcyI6WyJTdGF0ZVR5cGVzIiwiRXJyb3JUeXBlcyJdLCJtYXBwaW5ncyI6IkFBQUEsV0FBWUEsVUFBWjs7V0FBWUEsVTtBQUFBQSxFQUFBQSxVO0FBQUFBLEVBQUFBLFU7QUFBQUEsRUFBQUEsVTtBQUFBQSxFQUFBQSxVO0dBQUFBLFUsS0FBQUEsVTs7QUFPWixXQUFZQyxVQUFaOztXQUFZQSxVO0FBQUFBLEVBQUFBLFU7R0FBQUEsVSxLQUFBQSxVIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGVudW0gU3RhdGVUeXBlcyB7XG4gIE5PTkUgPSAnTk9ORScsXG4gIENBTVBBSUdOX1JFUVVFU1RFRCA9ICdDQU1QQUlHTl9SRVFVRVNURUQnLFxuICBVSV9SRVFVRVNURUQgPSAnVUlfUkVRVUVTVEVEJyxcbiAgVUlfRElTUExBWUVEID0gJ1VJX0RJU1BMQVlFRCcsXG59XG5cbmV4cG9ydCBlbnVtIEVycm9yVHlwZXMge1xuICBJTlZBTElEX1NUQVRFID0gJ0lOVkFMSURfU1RBVEUnLFxufVxuIl19